import React from 'react';
import { Box } from '../Box/Box';
import styles from './PageContainer.module.less';

/**
 * The <PageContainer> component standardizes the spacing above and below page content. It is
 * generally used with `<CenteredContainer>` to build a page's high-level layout.
 */
export var PageContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    className: styles.container,
    ref: ref
  }, children);
});